import { getAPIHeaders } from "../app/utils";
import { serverApi } from "../services/services";

export const postRequest = async ({
  url,
  payload = null,
  reqOptions = {},
  headers,
}) => {
  try {
    const reqOpts = getAPIHeaders({ headers });
    const response = await serverApi.post(url, payload, {
      ...reqOpts,
      ...reqOptions,
    });
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getRequest = async ({ url, query = null, reqOptions = {} }) => {
  try {
    const reqOpts = getAPIHeaders({ queryParams: query });
    const response = await serverApi.get(url, { ...reqOpts, ...reqOptions });
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putRequest = async ({
  url,
  query = null,
  payload = null,
  reqOptions = {},
}) => {
  try {
    const reqOpts = getAPIHeaders({ queryParams: query });
    const response = await serverApi.put(url, payload, {
      ...reqOpts,
      ...reqOptions,
    });
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
